<script>
import AppDisplay from '@/components/AppDisplay.vue'
import Bioinsumos from '../components/Bioinsumos.vue'
import Irrigacao from '../components/Irrigacao.vue'
import Financiamento from '../components/Financiamento.vue'
import Descricao from '../components/Descricao.vue'
import { culturas } from '@/libs/constants/praticas/opcoesSelects'
import { formataStringYearMonthToBr } from '@/utils/utils'

export default {
  components: {
    AppDisplay,
    Bioinsumos,
    Irrigacao,
    Financiamento,
    Descricao
  },
  props: {
    praticas: {
      type: Array
    }
  },
  methods: {
    formataDataInicio (value) {
      if (!value) return ''
      return formataStringYearMonthToBr(value)
    },
    formataPrevisoes (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => `• Cultura: ${culturas.find(cultura => cultura.id === value.cultura).nome} / Previsão de colheita: ${formataStringYearMonthToBr(value.previsaoColheita)} / Produtividade (sacas/hectare): ${value.produtividade}`)
      return opcoesFormatadas.join('<br /> ')
    }
  }
}
</script>

<template>
  <div>
    <el-collapse>
      <el-collapse-item v-for="(pratica, index) in praticas.filter(pratica => pratica.ano)" :key="pratica.ano + '_' + index" :title="'Ano: ' + pratica.ano">
        <div>
          <span class="title-praticas">Dados da prática</span>
          <hr />
        </div>
        <el-row>
          <el-col :span="12">
            <app-display label="Ano/Safra:" :content="pratica.ano" />
            <app-display label="Previsão de colheita e produtividade (mês e ano/ sacas por hectare):" :content="formataPrevisoes(pratica.previsoesColheitaProdutividade)" :isContentInNextLine="true" />
          </el-col>
          <el-col :span="12">
            <app-display label="Área destinada à plantio direto de grãos (em hectares):" :content="pratica.areaDestinada" />
            <app-display label="Data de início da prática de plantio direto na área (mês e ano):" :content="formataDataInicio(pratica.dataInicio)" />

          </el-col>
        </el-row>
          <Bioinsumos :bioinsumo="{utilizaBioinsumos: pratica.utilizaBioinsumos, bioinsumos: pratica.bioinsumos}" />
          <Irrigacao :irrigacao="{possuiIrrigacao: pratica.possuiIrrigacao, ...pratica.irrigacao}" />
          <Financiamento :financiamento="{financiamentos: pratica.financiamentos, outroFinanciamento: pratica.outroFinanciamento}" />
          <Descricao :descricao="pratica.descricao" />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/SPDG/SPDG.vue